import { render } from "./MenuIcon.vue?vue&type=template&id=4776230e&scoped=true"
const script = {}

import "./MenuIcon.vue?vue&type=style&index=0&id=4776230e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4776230e"]])

export default __exports__